module.exports = __webpack_public_path__ + "static/media/undraw_reading_time_gvg1.e75dad18.svg";